import React, { useState } from "react";
import { Modal,Col,Card,Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";
import {useForm} from "react-hook-form";
import ReactTost from "../../ReactTost";
import BtnLoader from './../../BtnLoader';

const ChangePassword = (props) => {
  const {t} = useTranslation();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const{handleSubmit, register, formState:{errors},reset }=useForm();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [loader, setLoading] = useState(false);

  const handleClose = () => {
    reset();
    props.onHide();
  };

  function ChangePassword(data) {
    if (data.password) {
      if (data.password !== data.confirmPassword) {
        setType("Danger");
        setMessage(t("Password and confirm password not match."));
        setShowAlert(true);
        return false;
      } else {
        setLoading(true);
        axios
          .patch(
            `${API_URL}/${API_VERSION}/changePassword/${props.id}`,
            {
              password:data.password,
            },
            {
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            setLoading(false);
            props.onHide();
            reset();
            setType("Success");
            setMessage(t("Password is changed."));
            setShowAlert(true);
           
          })
          .catch((error) => {
            setLoading(false);
            setType("Danger");
            setMessage(
              error.response.data.message
                ? error.response.data.message
                : t("Something went to wrong.")
            );
            setShowAlert(true);
          });
      }
    }
  }

  return (
    <>
     <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered  onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Change Password")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col md={12}>             
            <Col md={12} className="mb-4">
              <Card>
                <form onSubmit={handleSubmit(ChangePassword)}>
                <Card.Body className="p-4">
                  <h4>{t("Change password")}</h4>
                    <Col md={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">
                          {t("New password")}
                        </label>
                        <input
                          type="password"
                          className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                          id="newPassword"
                          name="newPassword"
                          {...register('password',{required:"New password is required"})}
                        />
                        {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="form-group mb-3">
                        <label className="form-label">
                          {t("Confirm password")}
                        </label>
                        <input
                          type="password"
                          className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                          id="confirmPassword"
                          name="confirmPassword"
                          {...register('confirmPassword',{required:"Confirm Password is required"})}
                        />
                        {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword.message}</div>}
                      </div>
                    </Col>
                </Card.Body>
                <Card.Footer>
                    <Col md={12} className="text-end">
                      <Button type="submit" className="userbutton mt-3">
                        {loader ? <BtnLoader/>: t("Change Password")}
                      </Button>
                    </Col>
                </Card.Footer>
                </form>
              </Card>
            </Col>
          </Col>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePassword;
